import React from 'react'

export default function Input({ type = 'text', name, label, placeholder, onChange, value, onBlur }) {
  return (
    <div className="form-group">
      <label htmlFor="exampleInputEmail1">{ label }</label>
      <input type={ type } name={ name } onChange={ onChange } value={ value } onBlur={ onBlur } className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder={ placeholder } />
    </div>
  )
}